module.exports = __webpack_public_path__ + "img/phone-blue.2d38cb48.svg";